import React from "react";
import { useRootAppStore } from "@hooks";

export default function Currency(props: {
	component?: string;
	className?: string;
}) {
	const userStore = useRootAppStore().userAuthStore;

	return (
		<>
			{props.component != null && props.className != null
				? React.createElement(
						props.component,
						props,
						userStore.currency
					)
				: userStore.currency}
		</>
	);
}
